import { render, staticRenderFns } from "./DeleteCourseLessonPopup.vue?vue&type=template&id=254c42c8"
import script from "./DeleteCourseLessonPopup.vue?vue&type=script&lang=js"
export * from "./DeleteCourseLessonPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports